import { dynamicImport } from '@core/helpers'
import { ROUTES } from '@router'

export default () => {
  // these routes are on the /dashboard/ so they need to be wrapped under the locale in the URL.
  // separated from ./routes.js to have them wrapped under the locale at once.
  return [
    // Customer Request - Diagnostic.
    {
      path: '/dashboard/sav/diagnostic/:orderlineId',
      name: ROUTES.DIAGNO,
      meta: { rollout: false },
    },
    // Customer Request - Claim creation
    {
      path: '/dashboard/claim/new/:orderlineId/:tilesIds',
      name: ROUTES.DASHBOARD.DIAGNOSIS.SELF,
      component: () => dynamicImport(import('@customer-requests/Diagnosis')),
      meta: {
        auth: {
          required: true,
        },
      },
    },
    // Customer Request - Contact form confirmation (remote assistance)
    {
      path: '/dashboard/claim/confirmation/:customerRequestId?',
      name: ROUTES.DASHBOARD.DIAGNOSIS.CONTACT_CONFIRMATION,
      component: () =>
        dynamicImport(
          import('@customer-requests/Diagnosis/ContactConfirmationPage'),
        ),
      meta: {
        auth: {
          required: true,
        },
      },
    },
    // Customer Request - Return funnel confirmation
    {
      path: '/dashboard/claim/return/confirmation/:customerRequestId',
      name: ROUTES.DASHBOARD.DIAGNOSIS.RETURN_CONFIRMATION,
      component: () =>
        dynamicImport(
          import('@customer-requests/Diagnosis/ReturnConfirmationPage'),
        ),
      meta: {
        auth: {
          required: true,
        },
      },
    },
    // Customer request - SAV Discussion.
    {
      path: '/dashboard/customer-request/:customerRequestId',
      name: ROUTES.SAV_CONVERSATION,
      component: () =>
        dynamicImport(import('@sav-discussion/ConnectedDiscussion')),
      meta: {
        auth: {
          required: true,
        },
      },
    },
  ]
}
